module.exports = __webpack_public_path__ + "static/media/director-loan.1baa5396.svg";